import { CompanyMarginsState } from './company-margins-state.model';

export const INITIAL_COMPANY_MARGINS_STATE: CompanyMarginsState = {
  margins: [],
  isLoading: false,
  error: null,
  isSaving: false,
  saveError: null,
};
